import { render, staticRenderFns } from "./Playing.vue?vue&type=template&id=6fd21830&scoped=true"
import script from "./Playing.vue?vue&type=script&lang=js"
export * from "./Playing.vue?vue&type=script&lang=js"
import style0 from "./Playing.vue?vue&type=style&index=0&id=6fd21830&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fd21830",
  null
  
)

export default component.exports